import type { FunctionComponent, PropsWithChildren } from 'react'
import React, { createContext, useContext, useState } from 'react'

const LayoutMilkStateContext = createContext<{
  totalHeaderHeight: number | undefined
  setTotalHeaderHeight: (height: number) => void
  topHeaderHeight: number | undefined
  setTopHeaderHeight: (height: number) => void
  TOSModalShown: boolean
  setTOSModalShown: (shown: boolean) => void
} | null>(null)

export const LayoutMilkStateContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [totalHeaderHeight, setTotalHeaderHeight] = useState<number | undefined>(undefined)
  const [topHeaderHeight, setTopHeaderHeight] = useState<number | undefined>(undefined)
  const [TOSModalShown, setTOSModalShown] = useState(false)

  return (
    <LayoutMilkStateContext.Provider value={{ totalHeaderHeight, setTotalHeaderHeight, topHeaderHeight, setTopHeaderHeight, TOSModalShown, setTOSModalShown }}>
      {children}
    </LayoutMilkStateContext.Provider>
  )
}

export const useLayoutMilkState = () => {
  const ctx = useContext(LayoutMilkStateContext)
  if (!ctx) throw new Error('Missing LayoutMilkStateContext for useLayoutMilkState')
  return ctx
}
